import { render } from "./PersonalCheckupList.vue?vue&type=template&id=5b2506b3&scoped=true"
import script from "./PersonalCheckupList.vue?vue&type=script&lang=js"
export * from "./PersonalCheckupList.vue?vue&type=script&lang=js"

import "./PersonalCheckupList.vue?vue&type=style&index=0&id=5b2506b3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2506b3"]])

export default __exports__